<template>
  <div class="form-group">
    <label class="form-label">Тип события*</label>
    <CustomSelect name="cause" @initialize="onEventSelectInitialize" @itemSelected="onEventSelectItemSelected">
      <option value="CarAccident">ДТП</option>
      <option value="OtherTrauma">Иная травма</option>
      <option value="Disease">Болезнь</option>
      <option value="Accident">Несчастный случай</option>
    </CustomSelect>
  </div>
</template>

<script>
import * as mns from "@/store/mutation-types";
import CustomSelect from "@/components/utils/CustomSelect";
export default {
anotherNameLife: "DeathSelect",
  components: {CustomSelect},
  methods: {
    onEventSelectInitialize(event){
      this.$store.commit(mns.SET_CAUSE, event.getValue().value);
    },
    onEventSelectItemSelected(event){
      this.$store.commit(mns.SET_CAUSE, event.detail.choice.value);
    },
  },
}
</script>

<style scoped>

</style>